import moment from "moment";
import React from "react";
import { Row, Col } from "react-bootstrap";
import {
    RiMoneyDollarCircleLine,
    RiFileWarningLine,
    RiLineChartLine,
    RiBankCardLine,
    RiFileList3Line
} from "react-icons/ri";

function BillingStats({ analytics }) {

    const stats = [
        // {
        //     title: "Current Balance",
        //     value: "$2,450.75",
        //     sub: "Due in 5 days",
        //     icon: <RiMoneyDollarCircleLine />,
        //     color: "blue",
        //     subColor: "danger"
        // },
        // {
        //     title: "Past Due",
        //     value: "$320.00",
        //     sub: "1 Invoice",
        //     icon: <RiFileWarningLine />,
        //     color: "green",
        //     subColor: "danger"
        // },
        {
            title: `This Month (${moment().local().format("MMM, YYYY")})`,
            value: `${analytics?.currentMonthTotal ? `$${analytics.currentMonthTotal.toFixed(2)}` : "$0.00"}`,
            // sub: "+12% vs Mar 2026",
            icon: <RiLineChartLine />,
            color: "purple",
            subColor: "success"
        },
        {
            title: "Total Paid (YTD)",
            value: `${analytics?.totalPaid ? `$${analytics.totalPaid.toFixed(2)}` : "$0.00"}`,
            // sub: "23 Payments",
            icon: <RiBankCardLine />,
            color: "orange",
            subColor: "muted"
        },
        {
            title: "Unpaid Invoices",
            value: analytics?.unpaidInvoicesCount || "0",
            // sub: "View Invoices",
            icon: <RiFileList3Line />,
            color: "blue",
            subColor: "primary"
        },
    ];

    return (
        <Row className="billing-stats gx-3">
            {stats.map((item, i) => (
                <div className="stat-col" key={i}>
                    <div className="stat-card">
                        <div className={`icon ${item.color}`}>{item.icon}</div>

                        <div className="content">
                            <p className="title ">{item.title}</p>
                            <h4 className="mb-0">{item.value}</h4>
                            <span className={`sub ${item.subColor}`}>
                                {item.sub}
                            </span>
                        </div>
                    </div>
                </div>
            ))}
        </Row>
    );
}

export default React.memo(BillingStats);